import OpportunityWizard from './OpportunityWizard';

export default OpportunityWizard;
